module.exports = __webpack_public_path__ + "static/media/stock21.200de445.jpg";